<template>
  <v-container grid-list-xl fluid fill-height>
    <v-layout column align-center justify-center>
      <v-card
        width="100%"
        max-width="500"
        max-height="500"
        outlined
        class="overflow-y-auto">
        <v-card-title>
          Selecciona un proveedor
        </v-card-title>
        <v-layout wrap>
          <v-flex md12>
            <v-list-item
              v-for="provider in providers"
              :key="provider._id"
              @click="selectProvider(provider)"
            >
              <v-list-item-avatar>
                <v-avatar color="primary" size="36">
                  <span class="white--text headline">{{ provider.name | initial }}</span>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="provider.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-flex>
        </v-layout>
      </v-card>
      <v-btn href="/logout" text rounded class="ma-2 red--text">Cerrar sesión</v-btn>
    </v-layout>
    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {
      overlay: false
    }
  },
  async beforeMount () {
    if (!this.userId) {
      this.$router.push('/logout')
    }
    if (!this.providers.length) {
      await this.$store.dispatch('login/loadLoginData')
    }
  },
  computed: {
    ...mapState({
      providers: state => state.login.providers.data
    }),
    permissions () {
      return this.$store.state.login.permissions
    },
    userId () {
      return this.$store.state.login.user._id
    }
  },
  watch: {
    providers: {
      handler (val) {
        if (!val.length) {
          this.$router.push({ name: 'Welcome' })
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'currentProvider/select'
    ]),
    async selectProvider (provider) {
      await this['currentProvider/select'](provider)
      if (this.permissions['purchase-orders'].visible) {
        await this.$store.dispatch('getUnits')
        this.$router.push({ name: 'ProviderInbox' })
      } else {
        this.$router.push({ name: 'PurchaseOrdersShoppingList' })
      }
    }
  }
}
</script>
